import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "../pages/Home";
import Login from "../pages/Login";
import ProtectedRoute from "../components/ProtectedRoute";
import Receive from "../pages/Receive";
import Auth from "../pages/Auth";
import ImportItem from "../pages/ImportItem";
import AccuratePosting from "../pages/AccuratePosting";

const AppRouter = () => {
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          key="home"
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />
        <Route
          path="/receive"
          key="receive"
          element={
            <ProtectedRoute>
              <Receive />
            </ProtectedRoute>
          }
        />
        <Route
          path="/import-item"
          key="import-item"
          element={
            <ProtectedRoute>
              <ImportItem />
            </ProtectedRoute>
          }
        />
        <Route
          path="/accurate-posting"
          key="accurate-posting"
          element={
            <ProtectedRoute>
              <AccuratePosting />
            </ProtectedRoute>
          }
        />

        <Route path="/auth" element={<Auth />} key="auth" />
        <Route path="/login" element={<Login />} key="login" />
      </Routes>
    </Router>
  );
};

export default AppRouter;
